module.exports = __webpack_public_path__ + "img/user_yes_real.35a47ed9.png";